import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: string[] = [];

const undraggableCardsSlice = createSlice({
	name: 'undraggableCards',
	initialState,
	reducers: {
		setUndraggableCards: (state, action: PayloadAction<string[]>) => {
			return action.payload;
		}
	}
});

export const { setUndraggableCards } = undraggableCardsSlice.actions;

export default undraggableCardsSlice.reducer;
